// extracted by mini-css-extract-plugin
export default {"report":"ContactHistory_report__67GFN","report-header":"ContactHistory_report-header__qCg9U"};